import { render, staticRenderFns } from "./CustomCDN.vue?vue&type=template&id=0d175fcc&scoped=true&"
import script from "./CustomCDN.vue?vue&type=script&lang=js&"
export * from "./CustomCDN.vue?vue&type=script&lang=js&"
import style0 from "./CustomCDN.vue?vue&type=style&index=0&id=0d175fcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d175fcc",
  null
  
)

export default component.exports